"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Root API interface.
 *
 * @example
 * ```ts
 * import Nekostore from 'nekostore';
 * import BasicDriver from 'nekostore/lib/driver/basic';
 *
 * const driver = new BasicDriver();
 * const nekostore = new Nekostore(driver);
 *
 * const colRef = nekostore.collection<{ foo: string }>('c1');
 * ```
 */
class Nekostore {
    /**
     * @param driver Driver instance you chosen.
     */
    constructor(driver) {
        this.driver = driver;
    }
    /**
     * Get a reference of the collection.
     */
    collection(id) {
        return this.driver.collection(id);
    }
}
exports.default = Nekostore;
//# sourceMappingURL=Nekostore.js.map